module.exports = __webpack_public_path__ + "static/media/bg-cover-img.a049b5e9.jpg";